
<button *ngIf="isValidIndicator()" type="button" class="validation-message"
        [attr.aria-label]="validationErrorLabel"
        (click)="stopCellAction($event)" (mousedown)="stopCellAction($event)" (dblclick)="stopCellAction($event)"
        [ngbPopover]="tooltip" triggers="click hover" [closeDelay]="300" [autoClose]="true" container="body" popoverClass="validation-error"><esp-icon name="circle-alert"></esp-icon></button>
<span [class.push-right]="isValidIndicator()">{{params.valueFormatted}}</span>

<ng-template #tooltip>
  <div class="message-text">
    <p>{{"plan.dist.cell.validation.line1"|translate}}<br>
      {{"plan.dist.cell.validation.line2"|translate}}<br>
      <br>
      <b>{{"plan.dist.cell.validation.line3"|translate}}{{validationSum}}%</b></p>
  </div>
</ng-template>
